// Substituted when the bundle is deployed: keep the literal `globalThis.X`
// reads or substitution stops working.

declare global {
  var REDO_PARTNERS_PORTAL_SERVER_URL: string | undefined;
}

export const REDO_PARTNERS_PORTAL_SERVER_URL =
  // The public API server, which serves the portal at /partner/portal.
  globalThis.REDO_PARTNERS_PORTAL_SERVER_URL ||
  "http://localhost:8001/partner/portal";
